<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVaultStore } from '../../stores/vault'

const { t } = useI18n()
const vault = useVaultStore()

// 성장은 실제로 암호화 저장된 기록 수를 따른다(금고 해제 시 불러옴)
const count = computed(() => vault.entries.length)
const level = computed(() => Math.floor(count.value / 10) + 1)
const toNext = computed(() => 10 - (count.value % 10))
const xp = computed(() => (count.value % 10) / 10)
</script>

<template>
  <div class="me-card">
    <div class="me-mini"><div class="eyes"><i></i><i></i></div></div>
    <b>{{ t('left.meLevel', { lv: level }) }}</b>
    <p>{{ t('left.meCount', { n: count, left: toNext }) }}</p>
    <div class="xp"><i :style="{ '--w': xp }"></i></div>
  </div>
</template>
